// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Zoom: React.FC<{ width?: number; height?: number }> = ({ width = 24, height = 24 }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M9.74999946,2.25 C12.4294925,2.25 14.9054446,3.67949152 16.2451901,6 C17.5849371,8.32050705 17.5849371,11.1794922 16.2451901,13.5 C14.9054446,15.8205085 12.4294925,17.25 9.74999946,17.25 C7.07050824,17.25 4.59455538,15.8205085 3.25480914,13.5 C1.9150629,11.1794922 1.9150629,8.32050705 3.25480914,6 C4.59455538,3.67949152 7.07050824,2.25 9.74999946,2.25 Z M9.75,19.5 C12.0374994,19.5 14.1421881,18.7125006 15.8015628,17.3953128 L22.078125,23.671875 C22.5187497,24.1125011 23.2312503,24.1125011 23.6671872,23.671875 C24.1031227,23.2312489 24.1078119,22.5187497 23.6671872,22.0828128 L17.3953128,15.8015628 C18.7125006,14.1421881 19.5,12.0374994 19.5,9.75 C19.5,4.36406279 15.1359372,0 9.75,0 C4.36406279,0 0,4.36406279 0,9.75 C0,15.1359372 4.36406279,19.5 9.75000072,19.5 L9.75,19.5 Z M8.62500072,13.875 C8.62500072,14.4984369 9.12656307,15 9.75000072,15 C10.3734384,15 10.8750007,14.4984369 10.8750007,13.875 L10.8750007,10.875 L13.8750007,10.875 C14.4984376,10.875 15.0000007,10.3734376 15.0000007,9.75 C15.0000007,9.12656236 14.4984376,8.625 13.8750007,8.625 L10.8750007,8.625 L10.8750007,5.625 C10.8750007,5.00156307 10.3734384,4.5 9.75000072,4.5 C9.12656307,4.5 8.62500072,5.00156307 8.62500072,5.625 L8.62500072,8.625 L5.62500072,8.625 C5.00156307,8.625 4.50000072,9.12656236 4.50000072,9.75 C4.50000072,10.3734376 5.00156307,10.875 5.62500072,10.875 L8.62500072,10.875 L8.62500072,13.875 Z"
            />
        </svg>
    );
};

export default React.memo(Zoom);
